import type { MeResponse } from "@chat-yai/shared";
import { request } from "@/api/client";

export const meApi = {
  get() {
    return request<MeResponse>("/admin/me");
  },
  updateProfile(input: { display_name?: string }) {
    return request<{ ok: true }>("/admin/me/profile", {
      method: "PATCH",
      body: input,
    });
  },
  changePassword(input: { current_password: string; new_password: string }) {
    return request<{ ok: true }>("/admin/me/password", {
      method: "POST",
      body: input,
    });
  },
  changeEmail(input: { new_email: string }) {
    return request<{ ok: true; verification_sent: true }>("/admin/me/email", {
      method: "POST",
      body: input,
    });
  },
};
